import { CommonModule } from '@angular/common';
import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Subject, Subscription, skip, takeUntil } from 'rxjs';
import { FiltroBuscaSalvaComponent } from 'src/app/shared/components/filtros-busca/filtro-busca-salva/filtro-busca-salva.component';
import { FiltroBuscaSomenteComponent } from 'src/app/shared/components/filtros-busca/filtro-busca-somente/filtro-busca-somente.component';
import { FiltroCadastradaEmComponent } from 'src/app/shared/components/filtros-busca/filtro-cadastrada-em/filtro-cadastrada-em.component';
import { FiltroFaseObraComponent } from 'src/app/shared/components/filtros-busca/filtro-fase-obra/filtro-fase-obra.component';
import { FiltroPadraoObraComponent } from 'src/app/shared/components/filtros-busca/filtro-padrao-obra/filtro-padrao-obra.component';
import { FiltroRegiaoComponent } from 'src/app/shared/components/filtros-busca/filtro-regiao/filtro-regiao.component';
import { FiltroTerminoObraComponent } from 'src/app/shared/components/filtros-busca/filtro-termino-obra/filtro-termino-obra.component';
import {
  FiltroTipoObraComponent,
  TipoObra,
} from 'src/app/shared/components/filtros-busca/filtro-tipo-obra/filtro-tipo-obra.component';
import { EstadoFiltrosService } from 'src/app/shared/components/filtros-busca/service/estado/estado-filtros.service';
import { ResultadoFiltroService } from 'src/app/shared/components/filtros-busca/service/resultado-service/resultado-filtros.service';
import { DropdownToggleDirective } from 'src/app/shared/directives/dropdown-toggle.directive';
import { environment } from 'src/environments/environment';
import {
  ModalMensagemComponent,
  TipoModalMensagem,
} from 'src/app/shared/components/modal-mensagem/modal-mensagem.component';
import { ModalMaisFiltrosImobiliarioComponent } from '../../shared/components/filtros-busca/modal-mais-filtros-imobiliario/modal-mais-filtros-imobiliario.component';
import { PaginacaoFiltrosService } from '../service/paginacao-filtros.service';
import { FiltroBuscaEstadoService } from '../service/filtro-busca-estado.service';
import { UtilsService } from 'src/app/shared/services/utils/utils.service';
import { getFiltrosSafe, setFiltrosSafe } from './filtros-imobiliario.storage';

@Component({
  selector: 'app-filtro-busca-imobiliario',
  standalone: true,
  imports: [
    FiltroTipoObraComponent,
    FiltroPadraoObraComponent,
    FiltroFaseObraComponent,
    FiltroCadastradaEmComponent,
    FiltroBuscaSomenteComponent,
    FiltroTerminoObraComponent,
    FiltroBuscaSalvaComponent,
    FiltroRegiaoComponent,
    DropdownToggleDirective,
    CommonModule,
    FormsModule,
    ModalMensagemComponent,
  ],
  templateUrl: './filtro-busca-imobiliario.component.html',
  styleUrls: ['./filtro-busca-imobiliario.component.scss'],
})
export class FiltroBuscaImobiliarioComponent implements OnInit, OnChanges {
  BASE_IMG_URL: string = environment.BASE_IMG_URL;

  filtrosSelecionados: any = {};

  buscaSalvaId: number | null = null;
  searchIDLegacy: number | null = null;
  savedSearchName: string = '';

  modalMensagem: {
    tipo: TipoModalMensagem;
    titulo: string;
    mensagem: string;
  } | null = null;

  @Input() idModuloSelecionado?: number;
  @Input() temAcessoModulo: boolean = false;
  @Input() isEditingSavedSearch: boolean = false;
  @Output() filtrosChange = new EventEmitter<any>();
  @Output() resultadoChange = new EventEmitter<any>();
  @Output() loadingChange = new EventEmitter<boolean>();
  @ViewChild(FiltroRegiaoComponent) filtroRegiao?: FiltroRegiaoComponent;
  @ViewChild('nomeBuscaInput') nomeBuscaInput!: ElementRef<HTMLInputElement>;
  @ViewChild('nomeBuscaEditadaInput')
  nomeBuscaEditadaInput?: ElementRef<HTMLInputElement>;

  inputNomeBusca: boolean = false;
  isBulkUpdate: boolean = false;
  isBuscaSalvaInitializing: boolean = false;
  private buscaSalvaJaCarregada = false;

  modoEdicao: boolean = false;

  private originalFiltersSnapshot: string = '';
  private edicaoDirty: boolean = false;
  private isInitializing = false;
  private isProcessingBuscaSalva = false;
  private paginacaoSub?: Subscription;
  private destroy$ = new Subject<void>();
  private bloqueiaResetPadrao = false;
  private ordenacaoAtual: string = 'date:desc';

  constructor(
    private estadoFiltros: EstadoFiltrosService,
    private resultadoService: ResultadoFiltroService,
    private paginacaoService: PaginacaoFiltrosService,
    private filtroBuscaEstado: FiltroBuscaEstadoService,
    private bsModalService: BsModalService,
    private utilsService: UtilsService,
    private route: ActivatedRoute,
    private router: Router,
  ) {}

  private exibirMensagem(
    tipo: TipoModalMensagem,
    titulo: string,
    mensagem: string,
  ): void {
    this.modalMensagem = { tipo, titulo, mensagem };
  }

  onFecharModalMensagem(): void {
    this.modalMensagem = null;
  }

  ngOnInit() {
    this.isInitializing = true;

    const win: any = window as any;
    const buscaSalvaASP =
      win.buscaSalvaIdASP !== undefined
        ? win.buscaSalvaIdASP
        : win.idBuscaASP !== undefined
          ? win.idBuscaASP
          : null;

    this.route.queryParams
      .pipe(takeUntil(this.destroy$))
      .subscribe((params) => {
        const buscaIdQuery = params['buscaSalvaId'];

        const resolvedId = this.resolveBuscaSalvaId(
          buscaIdQuery,
          buscaSalvaASP,
        );

        if (resolvedId) {
          if (resolvedId === this.buscaSalvaId) {
            this.bloqueiaResetPadrao = true;
            return;
          }

          this.modoEdicao = true;
          this.buscaSalvaId = resolvedId;
          this.bloqueiaResetPadrao = true;

          this.popularBuscaSalvaPorId(resolvedId);
        } else {
          this.modoEdicao = false;
          this.buscaSalvaId = null;
          this.bloqueiaResetPadrao = false;

          const moduloId = this.idModuloSelecionado ?? 234;
          const estadoSalvo = this.filtroBuscaEstado.recuperar(moduloId);
          const idRestaurado = this.extrairBuscaSalvaIdValido(
            estadoSalvo?.buscaSalvaId,
          );
          if (idRestaurado) {
            this.buscaSalvaId = idRestaurado;
            this.savedSearchName =
              estadoSalvo.savedSearchName ?? this.savedSearchName;
          }
        }
      });

    setTimeout(() => {
      if (!this.bloqueiaResetPadrao) {
        const moduloId = this.idModuloSelecionado ?? 234;
        const estadoSalvo = this.filtroBuscaEstado.recuperar(moduloId);
        if (estadoSalvo?.filtros?.length) {
          this.restaurarEstadoSessao(estadoSalvo);
        } else {
          this.inicializarFiltrosDefault();
        }
      }

      this.paginacaoSub = this.paginacaoService.paginacao$
        .pipe(skip(1), takeUntil(this.destroy$))
        .subscribe((pag) => {
          if (!this.isInitializing) {
            this.submitFilterForm(pag);
          }
        });

      this.isInitializing = false;
    });
  }

  ngOnDestroy() {
    this.paginacaoSub?.unsubscribe();
  }
  ngOnChanges(changes: SimpleChanges) {
    if (
      changes['idModuloSelecionado'] &&
      !changes['idModuloSelecionado'].firstChange &&
      !this.bloqueiaResetPadrao
    ) {
      this.filtrosSelecionados = {};
      this.inicializarFiltrosDefault();
    }
  }

  private resolveBuscaSalvaId(queryId: any, aspId: any): number | null {
    const raw = queryId ?? aspId;

    if (raw === null || raw === undefined) return null;
    if (isNaN(Number(raw))) return null;

    return Number(raw) > 0 ? Number(raw) : null;
  }

  public popularBuscaSalvaPorId(searchID: number): void {
    if (this.buscaSalvaJaCarregada) {
      return;
    }
    this.buscaSalvaJaCarregada = true;
    if (!searchID) {
      console.warn(
        '[IMOB][popularBuscaSalvaPorId] searchID inválido:',
        searchID,
      );
      return;
    }

    this.bloqueiaResetPadrao = true;
    this.isBuscaSalvaInitializing = true;
    this.buscaSalvaId = searchID;

    this.resultadoService.getSavedSearchResult(searchID).subscribe({
      next: (response) => {
        if (response.success && response.data) {
          if (response.data.savedSearchName) {
            this.savedSearchName = response.data.savedSearchName;
          }

          this.aplicarFiltrosSalvos(response.data);
        }

        this.isBuscaSalvaInitializing = false;

        this.originalFiltersSnapshot = JSON.stringify(getFiltrosSafe());
        this.edicaoDirty = false;
      },
      error: (error) => {
        console.error('Erro ao buscar filtros da busca salva:', error);
        this.isBuscaSalvaInitializing = false;
      },
    });
  }

  atualizarPaginacao(page: number, pageSize: number, ordenation?: string) {
    this.submitFilterForm({ page, pageSize, ordenation });
  }

  private extrairBuscaSalvaIdValido(valor: unknown): number | null {
    return typeof valor === 'number' && valor > 0 ? valor : null;
  }

  private inicializarFiltrosDefault(): void {
    const tiposDefault: TipoObra[] = [
      { id: 1, description: 'Edifícios Residenciais', checked: true },
      { id: 2, description: 'Prédios de Escritórios', checked: true },
      { id: 35, description: 'Condomínios de Casas', checked: true },
    ];

    const buscarSomenteDefault = [
      {
        id: 1,
        description: 'Buscar somente obras sem responsáveis',
        checked: true,
      },
      { id: 2, description: 'Não incluir obras descartadas', checked: true },
    ];

    const cadastradaEmDefault = {
      id: 0,
      description: 'Indiferente',
      checked: true,
    };

    const filtrosDefault = [
      ...tiposDefault
        .filter((t) => t.checked)
        .map((t) => ({
          filtroGrupo: 'Tipo de Obra',
          filtroID: t.id,
          checked: true,
          description: t.description,
        })),
      ...buscarSomenteDefault
        .filter((b) => b.checked)
        .map((b) => ({
          filtroGrupo: 'Buscar somente',
          filtroID: b.id,
          checked: true,
          description: b.description,
        })),
      {
        filtroGrupo: 'Cadastrada Em',
        filtroID: cadastradaEmDefault.id,
        checked: true,
        description: cadastradaEmDefault.description,
      },
    ];

    setFiltrosSafe(filtrosDefault);

    const savedArr = getFiltrosSafe();
    this.reconstruirFiltrosSelecionados(savedArr, cadastradaEmDefault);

    this.estadoFiltros.setFiltros(savedArr);
    this.filtrosChange.emit(this.filtrosSelecionados);
    this.isInitializing = false;
    this.isBuscaSalvaInitializing = false;
  }

  private restaurarEstadoSessao(estado: any): void {
    setFiltrosSafe(estado.filtros);
    const savedArr = getFiltrosSafe();
    this.reconstruirFiltrosSelecionados(savedArr, { id: 0 });
    this.estadoFiltros.setFiltros(savedArr);
    this.filtrosChange.emit(this.filtrosSelecionados);
    this.buscaSalvaId = this.extrairBuscaSalvaIdValido(estado.buscaSalvaId);
    this.savedSearchName = estado.savedSearchName ?? this.savedSearchName;
    if (estado.paginacao) {
      this.paginacaoService.setPaginacao(estado.paginacao);
    }
    this.submitFilterForm(estado.paginacao);
  }

  private reconstruirFiltrosSelecionados(
    savedArr: any[],
    cadastradaEmDefault: any,
  ) {
    const terminoFiltro = savedArr.find(
      (f) => f.filtroGrupo === 'Término da Obra',
    );

    const cidadesArr = savedArr
      .filter((f) => f.filtroGrupo === 'Cidades')
      .flatMap((f) =>
        Array.isArray(f.filtroID)
          ? f.filtroID.map(Number)
          : String(f.filtroID)
              .split(',')
              .map((v) => Number(v.trim())),
      )
      .filter((v) => !isNaN(v));
    const distritosArr = savedArr
      .filter((f) => f.filtroGrupo === 'Distritos' || f.filtroGrupo === 'Localidade')
      .flatMap((f) =>
        Array.isArray(f.filtroID)
          ? f.filtroID.map(Number)
          : String(f.filtroID)
              .split(',')
              .map((v) => Number(v.trim())),
      )
      .filter((v) => !isNaN(v));
    const bairrosArr = savedArr
      .filter((f) => f.filtroGrupo === 'Bairros')
      .flatMap((f) =>
        Array.isArray(f.filtroID)
          ? f.filtroID.map(Number)
          : String(f.filtroID)
              .split(',')
              .map((v) => Number(v.trim())),
      )
      .filter((v) => !isNaN(v));
    this.filtrosSelecionados = {
      workTypeID: savedArr
        .filter((f) => f.filtroGrupo === 'Tipo de Obra')
        .map((f) => f.filtroID),
      patternWorkID: savedArr
        .filter((f) => f.filtroGrupo === 'Padrão da Obra')
        .map((f) => f.filtroID),
      workPhaseID: savedArr
        .filter((f) => f.filtroGrupo === 'Fase da Obra')
        .map((f) => f.filtroID),
      dateRegisteredUpdated:
        savedArr.find((f) => f.filtroGrupo === 'Cadastrada Em')?.filtroID ??
        cadastradaEmDefault.id,
      noResponsible: savedArr.some(
        (f) => f.filtroGrupo === 'Buscar somente' && f.filtroID === 1,
      )
        ? 1
        : 0,
      noDiscardedWork: savedArr.some(
        (f) => f.filtroGrupo === 'Buscar somente' && f.filtroID === 2,
      )
        ? 1
        : 0,
      regiao:
        savedArr.find((f) => f.filtroGrupo === 'Região')?.filtroID ?? null,
      cidades: cidadesArr,
      distritos: distritosArr,
      bairros: bairrosArr,
      workEndDateBegin: terminoFiltro?.dataInicio ?? null,
      workEndDateEnd: terminoFiltro?.dataFim ?? null,
    };
  }

  private updateFiltrosStorage(parcial: any, skipEmit?: boolean) {
    if (this.isInitializing) {
      return;
    }
    let filtros = getFiltrosSafe();
    let grupo = '';
    let novos: any[] = [];
    if (parcial.tipos) {
      grupo = 'Tipo de Obra';
      novos = parcial.tipos
        .filter((t) => t.checked)
        .map((t) => ({
          filtroGrupo: grupo,
          filtroID: t.id,
          checked: true,
          description: t.description,
        }));
    } else if (parcial.padroes) {
      grupo = 'Padrão da Obra';
      novos = parcial.padroes
        .filter((p) => p.checked)
        .map((p) => ({
          filtroGrupo: grupo,
          filtroID: p.id,
          checked: true,
          description: p.description,
        }));
    } else if (parcial.fases) {
      grupo = 'Fase da Obra';
      novos = parcial.fases
        .filter((f) => f.checked)
        .map((f) => ({
          filtroGrupo: grupo,
          filtroID: f.id,
          checked: true,
          description: f.description,
        }));
    } else if (parcial.cadastradaEm) {
      grupo = 'Cadastrada Em';
      novos = [
        {
          filtroGrupo: grupo,
          filtroID: parcial.cadastradaEm.id ?? parcial.cadastradaEm.value,
          checked: true,
          description: parcial.cadastradaEm.description,
        },
      ];
    } else if (parcial.buscarSomente) {
      grupo = 'Buscar somente';
      novos = parcial.buscarSomente
        .filter((b) => b.checked)
        .map((b) => ({
          filtroGrupo: grupo,
          filtroID: b.id,
          checked: true,
          description: b.description,
        }));
    } else if (parcial.terminoObra) {
      grupo = 'Término da Obra';
      novos = [
        {
          filtroGrupo: grupo,
          dataInicio: parcial.terminoObra.dataInicio,
          dataFim: parcial.terminoObra.dataFim,
        },
      ];
    }
    if (!grupo) return;
    filtros = [...filtros.filter((f) => f.filtroGrupo !== grupo), ...novos];
    const unique = Array.from(
      new Set(filtros.map((f) => JSON.stringify(f))),
    ).map((f) => JSON.parse(f));
    setFiltrosSafe(unique);
    const savedArr = getFiltrosSafe();
    this.reconstruirFiltrosSelecionados(savedArr, { id: 0 });
    this.estadoFiltros.setFiltros(savedArr);

    const moduloId = this.idModuloSelecionado ?? 234;
    this.filtroBuscaEstado.salvar(moduloId, {
      filtros: savedArr,
      paginacao: this.paginacaoService.getPaginacao(),
      buscaSalvaId: this.buscaSalvaId,
      savedSearchName: this.savedSearchName,
    });

    if (!skipEmit) {
      this.filtrosChange.emit(this.filtrosSelecionados);
      this.submitFilterForm();
    }
    this.markDirtyIfEditing();
  }

  onTiposObraChange(tipos: TipoObra[]) {
    if (this.isBulkUpdate) return;
    this.updateFiltrosStorage({ tipos });
  }

  onPadroesObraChange(padroes: any[]) {
    if (this.isBulkUpdate) return;
    this.updateFiltrosStorage({ padroes });
  }

  onFasesObraChange(fases: any[]) {
    if (this.isBulkUpdate) return;
    this.updateFiltrosStorage({ fases });
  }

  onCadastradaEmChange(cadastradaEm: any) {
    if (this.isBulkUpdate) return;
    this.updateFiltrosStorage({ cadastradaEm });
  }

  onBuscarSomenteChange(buscarSomente: any[]) {
    if (this.isBulkUpdate) return;
    this.updateFiltrosStorage({ buscarSomente });
  }

  onBuscaSalvaFiltros(filtrosApi: any) {
    const isManual = filtrosApi._manual === true;

    if (!isManual && this.buscaSalvaJaCarregada) return;
    if (this.isBuscaSalvaInitializing) return;

    if (isManual) {
      this.buscaSalvaJaCarregada = false;
    }

    const { _manual, ...filtrosApi2 } = filtrosApi;

    if (filtrosApi2.savedSearchName) {
      this.savedSearchName = filtrosApi2.savedSearchName;
    }

    const addressLocationID =
      filtrosApi2.addressLocationID ?? filtrosApi2.AddressLocationID;

    this.isProcessingBuscaSalva = true;

    const filtrosConvertidos: any[] = [];

    let tiposArray: number[] = [];
    if (Array.isArray(filtrosApi2.workTypeID)) {
      tiposArray = filtrosApi2.workTypeID;
    } else if (typeof filtrosApi2.workTypeID === 'string') {
      tiposArray = filtrosApi2.workTypeID.split(',').map(Number);
    }
    tiposArray.forEach((id: number) => {
      filtrosConvertidos.push({
        filtroGrupo: 'Tipo de Obra',
        filtroID: id,
        checked: true,
        description: this.getDescricaoTipoObra(id),
      });
    });

    if (filtrosApi2.noResponsible === 1) {
      filtrosConvertidos.push({
        filtroGrupo: 'Buscar somente',
        filtroID: 1,
        checked: true,
        description: 'Buscar somente obras sem responsáveis',
      });
    }
    if (filtrosApi2.noDiscardedWork === 1) {
      filtrosConvertidos.push({
        filtroGrupo: 'Buscar somente',
        filtroID: 2,
        checked: true,
        description: 'Não incluir obras descartadas',
      });
    }

    if (typeof filtrosApi2.dateRegisteredUpdated !== 'undefined') {
      filtrosConvertidos.push({
        filtroGrupo: 'Cadastrada Em',
        filtroID: filtrosApi2.dateRegisteredUpdated,
        checked: true,
        description: 'Indiferente',
      });
    }

    if (filtrosApi2.workEndDateBegin || filtrosApi2.workEndDateEnd) {
      filtrosConvertidos.push({
        filtroGrupo: 'Término da Obra',
        dataInicio: filtrosApi2.workEndDateBegin
          ? filtrosApi2.workEndDateBegin.split('T')[0]
          : null,
        dataFim: filtrosApi2.workEndDateEnd
          ? filtrosApi2.workEndDateEnd.split('T')[0]
          : null,
      });
    }

    if (filtrosApi2.addressStateID) {
      filtrosConvertidos.push({
        filtroGrupo: 'Região',
        filtroID: filtrosApi2.addressStateID,
        checked: true,
        description: 'Região',
      });
    }

    if (filtrosApi2.addressCityID) {
      const cidades = String(filtrosApi2.addressCityID).split(',').map(Number);
      cidades.forEach((id: number) => {
        filtrosConvertidos.push({
          filtroGrupo: 'Cidades',
          filtroID: id,
          checked: true,
          description: 'Cidade',
        });
      });
    }

    if (addressLocationID) {
      const localidades = String(addressLocationID).split(',').map(Number);
      localidades.forEach((id: number) => {
        filtrosConvertidos.push({
          filtroGrupo: 'Localidade',
          filtroID: id,
          checked: true,
          description: 'Localidade',
        });
      });
    }

    if (filtrosApi2.neighborhoodAddressID && filtrosApi2.neighborhoodAddressID !== '0') {
      const bairros = String(filtrosApi2.neighborhoodAddressID).split(',').map(Number);
      bairros.forEach((id: number) => {
        filtrosConvertidos.push({
          filtroGrupo: 'Bairros',
          filtroID: id,
          checked: true,
          description: 'Bairro',
        });
      });
    }

    let padraoArray: number[] = [];
    if (Array.isArray(filtrosApi2.patternWorkID)) {
      padraoArray = filtrosApi2.patternWorkID;
    } else if (typeof filtrosApi2.patternWorkID === 'string') {
      padraoArray = filtrosApi2.patternWorkID.split(',').map(Number);
    }
    padraoArray.forEach((id: number) => {
      filtrosConvertidos.push({
        filtroGrupo: 'Padrão da Obra',
        filtroID: id,
        checked: true,
        description: 'Padrão',
      });
    });

    let faseArray: number[] = [];
    if (Array.isArray(filtrosApi2.workPhaseID)) {
      faseArray = filtrosApi2.workPhaseID;
    } else if (typeof filtrosApi2.workPhaseID === 'string') {
      faseArray = filtrosApi2.workPhaseID.split(',').map(Number);
    }
    faseArray.forEach((id: number) => {
      filtrosConvertidos.push({
        filtroGrupo: 'Fase da Obra',
        filtroID: id,
        checked: true,
        description: 'Fase',
      });
    });

    if (filtrosApi2.SearchIDLegacy) {
      this.filtrosSelecionados.isSearchIDLegacy = true;
    } else {
      this.filtrosSelecionados.isSearchIDLegacy = false;
    }

    this.aplicarFiltrosSalvos(filtrosConvertidos);
    this.isProcessingBuscaSalva = false;
  }
  private getDescricaoTipoObra(id: number): string {
    const tipos: Record<number, string> = {
      1: 'Edifícios Residenciais',
      2: 'Prédios de Escritórios',
      35: 'Condomínios de Casas',
    };
    return tipos[id] || 'Tipo de obra desconhecido';
  }

  ngAfterViewInit() {
    this.resultadoChange.subscribe((res) => {});
  }

  onTerminoObraChange(terminoObra: { dataInicio: string; dataFim: string }) {
    if (this.isBulkUpdate) return;
    this.updateFiltrosStorage({ terminoObra });
  }

  onBuscasSalvasChange(buscaId: number) {
    if (buscaId > 0) {
      this.buscaSalvaId = buscaId;
      this.filtrosSelecionados.buscaSalvaID = buscaId;
      setFiltrosSafe([]);
      this.filtrosSelecionados = {};
      this.estadoFiltros.setFiltros([]);
      this.filtrosChange.emit(this.filtrosSelecionados);
      this.filtrosSelecionados.buscaSalvaID = buscaId;
      this.filtrosChange.emit(this.filtrosSelecionados);
      this.atualizarBuscaSalvaIdNaUrl(buscaId);

      return;
    }

    this.buscaSalvaId = null;
    this.savedSearchName = '';
    this.filtrosSelecionados.buscaSalvaID = buscaId;
    this.filtrosChange.emit(this.filtrosSelecionados);
    this.atualizarBuscaSalvaIdNaUrl(null);
    this.submitFilterForm();
  }

  private atualizarBuscaSalvaIdNaUrl(buscaId: number | null): void {
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { buscaSalvaId: buscaId || null },
      queryParamsHandling: 'merge',
      replaceUrl: true,
    });
  }

  public submitFilterForm(paginacao?: {
    page: number;
    pageSize: number;
    ordenation?: string;
  }): void {
    const moduloId = this.idModuloSelecionado ?? 234;
    if (moduloId !== 234) {
      return;
    }

    this.filtroBuscaEstado.salvar(moduloId, {
      filtros: getFiltrosSafe(),
      paginacao: paginacao ?? this.paginacaoService.getPaginacao(),
      buscaSalvaId: this.buscaSalvaId,
      savedSearchName: this.savedSearchName,
    });

    this.loadingChange.emit(true);

    const filtrosSalvos = getFiltrosSafe();

    const { dataInicio, dataFim } = this.getTerminoObraDates(filtrosSalvos);
    
    const regiaoID =
      this.utilsService.getFiltroValor(filtrosSalvos, 'Região') ||
      this.filtroRegiao?.defaultState ||
      0;

    const cidades = this.utilsService.getFiltroValores(
      filtrosSalvos,
      'Cidades',
    );
    const localidades = this.utilsService.getFiltroValores(
      filtrosSalvos,
      'Localidade',
    );
    const bairros = this.utilsService.getFiltroValores(
      filtrosSalvos,
      'Bairros',
    ) || [];
    const addressCityIDs = cidades;
    const addressLocationIDs = localidades;
    const neighborhoodAddressIDs = bairros;

    this.ordenacaoAtual = paginacao?.ordenation ?? this.ordenacaoAtual;

    const detailsAptIds = filtrosSalvos
      .filter((f) => f.filtroGrupo === 'detailsApt' && f.checked)
      .map((f) => f.filtroID);
    const detailsCoverageIds = filtrosSalvos
      .filter((f) => f.filtroGrupo === 'detailsCoverage' && f.checked)
      .map((f) => f.filtroID);
    const commonAreasIds = filtrosSalvos
      .filter((f) => f.filtroGrupo === 'commonAreas' && f.checked)
      .map((f) => f.filtroID);

    const body = {
      workID: 0,
      workTypeID:
        this.utilsService
          .getFiltroValores(filtrosSalvos, 'Tipo de Obra')
          .join(',') || '0',
      addressStateID: regiaoID,
      addressCityID: addressCityIDs.length
        ? addressCityIDs.map(Number).join(',')
        : '0',
      addressLocationID: addressLocationIDs.length
        ? addressLocationIDs.map(Number).join(',')
        : '0',
      neighborhoodAddressID: neighborhoodAddressIDs.length
        ? neighborhoodAddressIDs.map(Number).join(',')
        : '0',
      patternWorkID:
        this.utilsService
          .getFiltroValores(filtrosSalvos, 'Padrão da Obra')
          .join(',') || '0',
      workPhaseID:
        this.utilsService
          .getFiltroValores(filtrosSalvos, 'Fase da Obra')
          .join(',') || '0',
      dateRegisteredUpdated:
        this.utilsService.getFiltroValor(filtrosSalvos, 'Cadastrada Em') ?? 0,
      unitsBegin:
        this.utilsService.getFiltroValor(filtrosSalvos, 'unidadesDe') ?? 0,
      unitsEnd:
        this.utilsService.getFiltroValor(filtrosSalvos, 'unidadesAte') ??
        999999999,
      blocksBegin:
        this.utilsService.getFiltroValor(filtrosSalvos, 'blocosDe') ?? 0,
      blocksEnd:
        this.utilsService.getFiltroValor(filtrosSalvos, 'blocosAte') ??
        999999999,
      floorsBegin:
        this.utilsService.getFiltroValor(filtrosSalvos, 'pavimentosDe') ?? '0',
      floorsEnd:
        this.utilsService.getFiltroValor(filtrosSalvos, 'pavimentosAte') ??
        '999999999',
      totalAreaBegin:
        this.utilsService.getFiltroValor(filtrosSalvos, 'areaTotalDe') ?? 0,
      totalAreaEnd:
        this.utilsService.getFiltroValor(filtrosSalvos, 'areaTotalAte') ??
        999999999,
      meterSquareUnitBegin:
        this.utilsService.getFiltroValor(filtrosSalvos, 'metroQuadradoDe') ?? 0,
      meterSquareUnitEnd:
        this.utilsService.getFiltroValor(filtrosSalvos, 'metroQuadradoAte') ??
        999999999,
      bathroomsBegin:
        this.utilsService.getFiltroValor(filtrosSalvos, 'banheirosDe') ?? 0,
      bathroomsEnd:
        this.utilsService.getFiltroValor(filtrosSalvos, 'banheirosAte') ??
        999999999,
      parkingSpacesBegin:
        this.utilsService.getFiltroValor(filtrosSalvos, 'vagasDe') ?? 0,
      parkingSpacesEnd:
        this.utilsService.getFiltroValor(filtrosSalvos, 'vagasAte') ??
        999999999,
      workEndDateBegin: dataInicio,
      workEndDateEnd: dataFim,
      coveragesByBlockBegin: 0,
      coveragesByBlockEnd: 999999999,
      unitsPerFloorBegin: 0,
      unitsPerFloorEnd: 999999999,
      bedroomsBegin:
        this.utilsService.getFiltroValor(filtrosSalvos, 'dormitoriosDe') ?? 0,
      bedroomsEnd:
        this.utilsService.getFiltroValor(filtrosSalvos, 'dormitoriosAte') ??
        999999999,
      suitesBegin:
        this.utilsService.getFiltroValor(filtrosSalvos, 'suitesDe') ?? 0,
      suitesEnd:
        this.utilsService.getFiltroValor(filtrosSalvos, 'suitesAte') ??
        999999999,
      detailsApt: detailsAptIds.length ? detailsAptIds.join(',') : '0',
      detailsCoverage: detailsCoverageIds.length
        ? detailsCoverageIds.join(',')
        : '0',
      commonAreas: commonAreasIds.length ? commonAreasIds.join(',') : '0',

      noResponsible: this.utilsService
        .getFiltroValores(filtrosSalvos, 'Buscar somente')
        .includes(1)
        ? 1
        : 0,
      noDiscardedWork: this.utilsService
        .getFiltroValores(filtrosSalvos, 'Buscar somente')
        .includes(2)
        ? 1
        : 0,
      pagination: {
        page: paginacao?.page ?? 1,
        pageSize: paginacao?.pageSize ?? 50,
        shortcuts: 10,
        ordenation: this.ordenacaoAtual,
      },
    };

    this.resultadoService.submitFilterForm(body).subscribe({
      next: (res) => {
        this.resultadoChange.emit(res);
        this.loadingChange.emit(false);
      },
      error: (err) => {
        this.resultadoChange.emit({ error: true, details: err });
        this.loadingChange.emit(false);
      },
    });
  }

  private getTerminoObraDates(filtrosSalvos: any[]): {
    dataInicio: string | null;
    dataFim: string | null;
  } {
    const filtro = filtrosSalvos.find(
      (f) => f.filtroGrupo === 'Término da Obra',
    );
    let dataInicio = null;
    let dataFim = null;
    if (filtro && filtro.dataInicio) {
      dataInicio = filtro.dataInicio ? filtro.dataInicio + 'T00:00:00Z' : null;
    }
    if (filtro && filtro.dataFim) {
      dataFim = filtro.dataFim ? filtro.dataFim + 'T00:00:00Z' : null;
    }
    return { dataInicio, dataFim };
  }

  onRegiaoChange(regiao: any): void {
    if (this.isBulkUpdate) return;
    if (this.isBuscaSalvaInitializing) return;
    let filtros = getFiltrosSafe().filter(
      (f) => !['Região', 'Cidades', 'Distritos', 'Localidade', 'Bairros'].includes(f.filtroGrupo),
    );

    filtros.push({
      filtroGrupo: 'Região',
      filtroID: regiao.regiao ?? regiao.addressStateID,
      checked: true,
      description: 'Região',
    });

    regiao.addressCityID?.forEach((c: number | string) =>
      filtros.push({
        filtroGrupo: 'Cidades',
        filtroID: c,
        checked: true,
        description: 'Cidade',
      }),
    );

    regiao.addressLocationID?.forEach((d: number | string) =>
      filtros.push({
        filtroGrupo: 'Localidade',
        filtroID: d,
        checked: true,
        description: 'Localidade',
      }),
    );

    regiao.neighborhoodAddressID?.forEach((n: number | string) =>
      filtros.push({
        filtroGrupo: 'Bairros',
        filtroID: n,
        checked: true,
        description: 'Bairro',
      }),
    );

    setFiltrosSafe(filtros);

    this.filtrosSelecionados = {
      ...this.filtrosSelecionados,
      regiao: regiao.regiao ?? regiao.addressStateID,
      addressCityID: regiao.addressCityID || [],
      cidades: regiao.addressCityID || [],
      addressLocationID: regiao.addressLocationID || [],
      localidades: regiao.addressLocationID || [],
      neighborhoodAddressID: regiao.neighborhoodAddressID || [],
      bairros: regiao.neighborhoodAddressID || [],
    };

    this.filtrosChange.emit(this.filtrosSelecionados);

    this.submitFilterForm();
    this.markDirtyIfEditing();
  }

  salvarBusca() {
    const nomeBusca = this.nomeBuscaInput.nativeElement.value.trim();
    if (!nomeBusca) {
      this.inputNomeBusca = false;
      setTimeout(() => {
        this.inputNomeBusca = true;
      }, 2000);
      return;
    }

    const filtrosSalvos = getFiltrosSafe();
    const { dataInicio, dataFim } = this.getTerminoObraDates(filtrosSalvos);
    const getFiltroValor = (grupo: string) =>
      filtrosSalvos.find((f) => f.filtroGrupo === grupo)?.filtroID;
    const getFiltroValores = (grupo: string) =>
      filtrosSalvos
        .filter((f) => f.filtroGrupo === grupo)
        .map((f) => f.filtroID);

    const regiaoID = getFiltroValor('Região') || 0;
    const cidades = getFiltroValores('Cidades');
    const localidades = getFiltroValores('Localidade');
    const bairros = getFiltroValores('Bairros') || [];

    const detailsAptIds = getFiltroValores('detailsApt');
    const detailsCoverageIds = getFiltroValores('detailsCoverage');
    const commonAreasIds = getFiltroValores('commonAreas');

    const body = {
      workID: 0,
      workTypeID: getFiltroValores('Tipo de Obra').join(',') || '0',
      addressStateID: regiaoID ? String(regiaoID) : '0',
      addressCityID: cidades.length ? cidades.map(Number).join(',') : '0',
      addressLocationID: localidades.length
        ? localidades.map(Number).join(',')
        : '0',
      neighborhoodAddressID: bairros.length
        ? bairros.map(Number).join(',')
        : '0',
      patternWorkID: getFiltroValores('Padrão da Obra').join(',') || '0',
      workPhaseID: getFiltroValores('Fase da Obra').join(',') || '0',
      unitsBegin: getFiltroValor('unidadesDe') ?? 0,
      unitsEnd: getFiltroValor('unidadesAte') ?? 999999999,
      blocksBegin: getFiltroValor('blocosDe') ?? 0,
      blocksEnd: getFiltroValor('blocosAte') ?? 999999999,
      floorsBegin: getFiltroValor('pavimentosDe') ?? '0',
      floorsEnd: getFiltroValor('pavimentosAte') ?? '999999999',
      totalAreaBegin: getFiltroValor('areaTotalDe') ?? 0,
      totalAreaEnd: getFiltroValor('areaTotalAte') ?? 999999999,
      meterSquareUnitBegin: getFiltroValor('metroQuadradoDe') ?? 0,
      meterSquareUnitEnd: getFiltroValor('metroQuadradoAte') ?? 999999999,
      bathroomsBegin: getFiltroValor('banheirosDe') ?? 0,
      bathroomsEnd: getFiltroValor('banheirosAte') ?? 999999999,
      parkingSpacesBegin: getFiltroValor('vagasDe') ?? 0,
      parkingSpacesEnd: getFiltroValor('vagasAte') ?? 999999999,
      workEndDateBegin: dataInicio,
      workEndDateEnd: dataFim,
      dateRegisteredUpdated: getFiltroValor('Cadastrada Em') ?? 0,
      coveragesByBlockBegin: 0,
      coveragesByBlockEnd: 999999999,
      unitsPerFloorBegin: 0,
      unitsPerFloorEnd: 999999999,
      bedroomsBegin: getFiltroValor('dormitoriosDe') ?? 0,
      bedroomsEnd: getFiltroValor('dormitoriosAte') ?? 999999999,
      suitesBegin: getFiltroValor('suitesDe') ?? 0,
      suitesEnd: getFiltroValor('suitesAte') ?? 999999999,
      detailsApt: detailsAptIds.length ? detailsAptIds.join(',') : '0',
      detailsCoverage: detailsCoverageIds.length
        ? detailsCoverageIds.join(',')
        : '0',
      commonAreas: commonAreasIds.length ? commonAreasIds.join(',') : '0',
      noResponsible: getFiltroValores('Buscar somente').includes(1) ? 1 : 0,
      noDiscardedWork: getFiltroValores('Buscar somente').includes(2) ? 1 : 0,
      pagination: {
        page: 1,
        pageSize: 50,
        shortcuts: 10,
        ordenation: '',
      },
      savedSearchName: nomeBusca,
    };

    this.resultadoService.saveSearch(body).subscribe({
      next: () => {
        this.exibirMensagem(
          'sucesso',
          'Busca salva com sucesso!',
          'Agora você pode acessá-la rapidamente através do menu de buscas salvas.',
        );
      },
      error: (err) => {
        console.error('Erro ao salvar busca:', err);
        this.exibirMensagem('erro', 'Erro', 'Erro ao salvar busca.');
      },
    });
  }

  salvarEdicaoBusca() {
    if (!this.buscaSalvaId) {
      this.exibirMensagem('erro', 'Erro', 'ID da busca não encontrado para edição.');
      return;
    }

    let nomeEdicao = this.savedSearchName.trim();
    if (this.nomeBuscaEditadaInput) {
      const val = this.nomeBuscaEditadaInput.nativeElement.value.trim();
      if (val) nomeEdicao = val;
    }

    const filtrosSalvos = getFiltrosSafe();
    const { dataInicio, dataFim } = this.getTerminoObraDates(filtrosSalvos);
    const getFiltroValor = (grupo: string) =>
      filtrosSalvos.find((f) => f.filtroGrupo === grupo)?.filtroID;
    const getFiltroValores = (grupo: string) =>
      filtrosSalvos
        .filter((f) => f.filtroGrupo === grupo)
        .map((f) => f.filtroID);

    const regiaoID = getFiltroValor('Região') || 0;
    const cidades = getFiltroValores('Cidades');
    const localidades = getFiltroValores('Localidade');
    const bairros = getFiltroValores('Bairros') || [];

    const detailsAptIds = getFiltroValores('detailsApt');
    const detailsCoverageIds = getFiltroValores('detailsCoverage');
    const commonAreasIds = getFiltroValores('commonAreas');

    const body = {
      searchId: this.buscaSalvaId,
      workID: 0,
      workTypeID: getFiltroValores('Tipo de Obra').join(',') || '0',
      addressStateID: regiaoID ? Number(regiaoID) : 0,
      addressCityID: cidades.length ? cidades.map(Number).join(',') : '0',
      addressLocationID: localidades.length
        ? localidades.map(Number).join(',')
        : '0',
      neighborhoodAddressID: bairros.length
        ? bairros.map(Number).join(',')
        : '0',
      patternWorkID: getFiltroValores('Padrão da Obra').join(',') || '0',
      workPhaseID: getFiltroValores('Fase da Obra').join(',') || '0',
      unitsBegin: getFiltroValor('unidadesDe') ?? 0,
      unitsEnd: getFiltroValor('unidadesAte') ?? 999999999,
      blocksBegin: getFiltroValor('blocosDe') ?? 0,
      blocksEnd: getFiltroValor('blocosAte') ?? 999999999,
      floorsBegin: getFiltroValor('pavimentosDe') ?? '0',
      floorsEnd: getFiltroValor('pavimentosAte') ?? '999999999',
      totalAreaBegin: getFiltroValor('areaTotalDe') ?? 0,
      totalAreaEnd: getFiltroValor('areaTotalAte') ?? 999999999,
      meterSquareUnitBegin: getFiltroValor('metroQuadradoDe') ?? 0,
      meterSquareUnitEnd: getFiltroValor('metroQuadradoAte') ?? 999999999,
      bathroomsBegin: getFiltroValor('banheirosDe') ?? 0,
      bathroomsEnd: getFiltroValor('banheirosAte') ?? 999999999,
      parkingSpacesBegin: getFiltroValor('vagasDe') ?? 0,
      parkingSpacesEnd: getFiltroValor('vagasAte') ?? 999999999,
      workEndDateBegin: dataInicio,
      workEndDateEnd: dataFim,
      dateRegisteredUpdated: getFiltroValor('Cadastrada Em') ?? 0,
      coveragesByBlockBegin: 0,
      coveragesByBlockEnd: 999999999,
      unitsPerFloorBegin: 0,
      unitsPerFloorEnd: 0,
      bedroomsBegin: getFiltroValor('dormitoriosDe') ?? 0,
      bedroomsEnd: getFiltroValor('dormitoriosAte') ?? 999999999,
      suitesBegin: getFiltroValor('suitesDe') ?? 0,
      suitesEnd: getFiltroValor('suitesAte') ?? 999999999,
      detailsApt: detailsAptIds.length ? detailsAptIds.join(',') : '0',
      detailsCoverage: detailsCoverageIds.length
        ? detailsCoverageIds.join(',')
        : '0',
      commonAreas: commonAreasIds.length ? commonAreasIds.join(',') : '0',
      noResponsible: getFiltroValores('Buscar somente').includes(1) ? 1 : 0,
      noDiscardedWork: getFiltroValores('Buscar somente').includes(2) ? 1 : 0,
      savedSearchName: nomeEdicao || this.savedSearchName || 'Busca Editada',
      searchIDLegacy: this.filtrosSelecionados.isSearchIDLegacy ? 1 : 0,
      pagination: {
        page: 1,
        pageSize: 50,
        shortcuts: 10,
        ordenation: '',
      },
    };

    this.loadingChange.emit(true);

    this.resultadoService.editSavdSearchs(body).subscribe({
      next: (res) => {
        this.loadingChange.emit(false);
        if (res?.success) {
          this.exibirMensagem('sucesso', 'Sucesso', 'Busca salva editada com sucesso!');
          this.savedSearchName = nomeEdicao;
          this.originalFiltersSnapshot = JSON.stringify(getFiltrosSafe());
          this.edicaoDirty = false;
        } else {
          this.exibirMensagem('atencao', 'Atenção', 'Edição concluída, mas resposta inesperada.');
          console.warn('Resposta edição busca:', res);
        }
      },
      error: (err) => {
        console.error('Erro ao editar busca salva:', err);
        this.loadingChange.emit(false);
        this.exibirMensagem('erro', 'Erro', 'Erro ao editar busca.');
      },
    });
  }
  public aplicarFiltrosSalvos(filtrosApi: any): void {
    this.isBulkUpdate = true;
    let filtrosArray: any[] = [];

    if (Array.isArray(filtrosApi)) {
      filtrosArray = filtrosApi;
    } else if (filtrosApi && typeof filtrosApi === 'object') {
      if (filtrosApi.workTypeID) {
        const tipos = String(filtrosApi.workTypeID).split(',').map(Number);
        tipos.forEach((id: number) => {
          filtrosArray.push({
            filtroGrupo: 'Tipo de Obra',
            filtroID: id,
            checked: true,
            description: this.getDescricaoTipoObra(id),
          });
        });
      }

      if (filtrosApi.patternWorkID) {
        const padroes = String(filtrosApi.patternWorkID).split(',').map(Number);
        padroes.forEach((id: number) => {
          filtrosArray.push({
            filtroGrupo: 'Padrão da Obra',
            filtroID: id,
            checked: true,
            description: 'Padrão',
          });
        });
      }

      if (filtrosApi.workPhaseID) {
        const fases = String(filtrosApi.workPhaseID).split(',').map(Number);
        fases.forEach((id: number) => {
          filtrosArray.push({
            filtroGrupo: 'Fase da Obra',
            filtroID: id,
            checked: true,
            description: 'Fase',
          });
        });
      }

      if (typeof filtrosApi.dateRegisteredUpdated !== 'undefined') {
        filtrosArray.push({
          filtroGrupo: 'Cadastrada Em',
          filtroID: filtrosApi.dateRegisteredUpdated,
          checked: true,
          description: 'Indiferente',
        });
      }

      if (filtrosApi.noResponsible === 1) {
        filtrosArray.push({
          filtroGrupo: 'Buscar somente',
          filtroID: 1,
          checked: true,
          description: 'Buscar somente obras sem responsáveis',
        });
      }

      if (filtrosApi.noDiscardedWork === 1) {
        filtrosArray.push({
          filtroGrupo: 'Buscar somente',
          filtroID: 2,
          checked: true,
          description: 'Não incluir obras descartadas',
        });
      }

      if (filtrosApi.addressStateID) {
        filtrosArray.push({
          filtroGrupo: 'Região',
          filtroID: filtrosApi.addressStateID,
          checked: true,
          description: 'Região',
        });
      }

      if (filtrosApi.addressCityID) {
        const cidades = String(filtrosApi.addressCityID).split(',').map(Number);
        cidades.forEach((id: number) => {
          filtrosArray.push({
            filtroGrupo: 'Cidades',
            filtroID: id,
            checked: true,
            description: 'Cidade',
          });
        });
      }

      const addressLocationID =
        filtrosApi.addressLocationID ?? filtrosApi.AddressLocationID;
      if (addressLocationID) {
        const localidades = String(addressLocationID).split(',').map(Number);
        localidades.forEach((id: number) => {
          filtrosArray.push({
            filtroGrupo: 'Localidade',
            filtroID: id,
            checked: true,
            description: 'Localidade',
          });
        });
      }

      if (filtrosApi.neighborhoodAddressID && filtrosApi.neighborhoodAddressID !== '0') {
        const bairros = String(filtrosApi.neighborhoodAddressID).split(',').map(Number);
        bairros.forEach((id: number) => {
          filtrosArray.push({
            filtroGrupo: 'Bairros',
            filtroID: id,
            checked: true,
            description: 'Bairro',
          });
        });
      }

      if (filtrosApi.workEndDateBegin || filtrosApi.workEndDateEnd) {
        filtrosArray.push({
          filtroGrupo: 'Término da Obra',
          dataInicio: filtrosApi.workEndDateBegin
            ? filtrosApi.workEndDateBegin.split('T')[0]
            : null,
          dataFim: filtrosApi.workEndDateEnd
            ? filtrosApi.workEndDateEnd.split('T')[0]
            : null,
        });
      }

      if (filtrosApi.detailsApt && filtrosApi.detailsApt !== '0') {
        const ids = String(filtrosApi.detailsApt).split(',').map(Number);
        ids.forEach((id: number) => {
          filtrosArray.push({
            filtroGrupo: 'detailsApt',
            filtroID: id,
            checked: true,
          });
        });
      }

      if (filtrosApi.detailsCoverage && filtrosApi.detailsCoverage !== '0') {
        const ids = String(filtrosApi.detailsCoverage).split(',').map(Number);
        ids.forEach((id: number) => {
          filtrosArray.push({
            filtroGrupo: 'detailsCoverage',
            filtroID: id,
            checked: true,
          });
        });
      }

      if (filtrosApi.commonAreas && filtrosApi.commonAreas !== '0') {
        const ids = String(filtrosApi.commonAreas).split(',').map(Number);
        ids.forEach((id: number) => {
          filtrosArray.push({
            filtroGrupo: 'commonAreas',
            filtroID: id,
            checked: true,
          });
        });
      }

      const numericos = [
        { grupo: 'unidadesDe', campo: 'unitsBegin', padrao: 0 },
        { grupo: 'unidadesAte', campo: 'unitsEnd', padrao: 999999999 },
        { grupo: 'blocosDe', campo: 'blocksBegin', padrao: 0 },
        { grupo: 'blocosAte', campo: 'blocksEnd', padrao: 999999999 },
        { grupo: 'pavimentosDe', campo: 'floorsBegin', padrao: 0 },
        { grupo: 'pavimentosAte', campo: 'floorsEnd', padrao: 999999999 },
        { grupo: 'areaTotalDe', campo: 'totalAreaBegin', padrao: 0 },
        { grupo: 'areaTotalAte', campo: 'totalAreaEnd', padrao: 999999999 },
        { grupo: 'metroQuadradoDe', campo: 'meterSquareUnitBegin', padrao: 0 },
        {
          grupo: 'metroQuadradoAte',
          campo: 'meterSquareUnitEnd',
          padrao: 999999999,
        },
        { grupo: 'banheirosDe', campo: 'bathroomsBegin', padrao: 0 },
        { grupo: 'banheirosAte', campo: 'bathroomsEnd', padrao: 999999999 },
        { grupo: 'vagasDe', campo: 'parkingSpacesBegin', padrao: 0 },
        { grupo: 'vagasAte', campo: 'parkingSpacesEnd', padrao: 999999999 },
        { grupo: 'dormitoriosDe', campo: 'bedroomsBegin', padrao: 0 },
        { grupo: 'dormitoriosAte', campo: 'bedroomsEnd', padrao: 999999999 },
        { grupo: 'suitesDe', campo: 'suitesBegin', padrao: 0 },
        { grupo: 'suitesAte', campo: 'suitesEnd', padrao: 999999999 },
      ];

      numericos.forEach(({ grupo, campo, padrao }) => {
        const valor = filtrosApi[campo];
        if (valor !== undefined && valor !== padrao) {
          filtrosArray.push({
            filtroGrupo: grupo,
            filtroID: valor,
            checked: true,
          });
        }
      });

      if (filtrosApi.SearchIDLegacy) {
        this.filtrosSelecionados.isSearchIDLegacy = true;
      } else {
        this.filtrosSelecionados.isSearchIDLegacy = false;
      }
    }

    const filtrosChecked = filtrosArray.map((f) => ({ ...f, checked: true }));

    setFiltrosSafe(filtrosChecked);
    this.reconstruirFiltrosSelecionados(filtrosChecked, { id: 0 });
    this.estadoFiltros.setFiltros(filtrosChecked);
    this.filtrosChange.emit(this.filtrosSelecionados);

    setTimeout(() => {
      this.isBulkUpdate = false;
      this.submitFilterForm();
    }, 0);
  }
  limparFiltros() {
    this.filtroBuscaEstado.limpar(this.idModuloSelecionado ?? 234);
    setFiltrosSafe([]);
    let filtros = getFiltrosSafe().filter(
      (f) => f.filtroGrupo !== 'Buscar somente',
    );
    setFiltrosSafe(filtros);
    this.filtrosSelecionados = {
      workTypeID: [],
      patternWorkID: [],
      workPhaseID: [],
      dateRegisteredUpdated: 0,
      noResponsible: 0,
      noDiscardedWork: 0,
      regiao: null,
      cidades: [],
      distritos: [],
      workEndDateBegin: null,
      workEndDateEnd: null,
    };
    this.estadoFiltros.setFiltros([]);
    this.filtrosChange.emit(this.filtrosSelecionados);

    this.filtroRegiao?.restaurarPadrao();

    setTimeout(() => {
      this.onBuscarSomenteChange([]);
    }, 0);
    this.submitFilterForm();
    this.markDirtyIfEditing();
  }

  openModal() {
    const modalRef = this.bsModalService.show(
      ModalMaisFiltrosImobiliarioComponent,
      {
        class: 'modal-lg',
        ignoreBackdropClick: true,
      },
    );
    if (modalRef && modalRef.content && modalRef.content.filtrosModalChange) {
      modalRef.content.filtrosModalChange.subscribe(() => {
        this.submitFilterForm();
      });
    }
  }
  get checkedBuscarSomenteIds(): number[] {
    const arr: number[] = [];
    if (
      this.filtrosSelecionados &&
      this.filtrosSelecionados.noResponsible === 1
    )
      arr.push(1);
    if (
      this.filtrosSelecionados &&
      this.filtrosSelecionados.noDiscardedWork === 1
    )
      arr.push(2);
    return arr;
  }

  onNomeEdicaoChange(valor: string) {
    this.savedSearchName = valor;
    this.markDirtyIfEditing(true);
  }

  private markDirtyIfEditing(force?: boolean) {
    if (!this.modoEdicao) return;
    if (this.isBuscaSalvaInitializing) return;
    const current = JSON.stringify(getFiltrosSafe());
    if (force) {
      if (current !== this.originalFiltersSnapshot) this.edicaoDirty = true;
      return;
    }
    if (!this.originalFiltersSnapshot) {
      this.originalFiltersSnapshot = current;
      this.edicaoDirty = false;
      return;
    }
    this.edicaoDirty = current !== this.originalFiltersSnapshot;
  }

  public hasUnsavedChanges(): boolean {
    return this.modoEdicao && this.edicaoDirty;
  }

  @HostListener('window:beforeunload', ['$event'])
  handleBeforeUnload(event: BeforeUnloadEvent): void {
    if (this.hasUnsavedChanges()) {
      const message =
        'Você possui alterações não salvas na busca em edição. Deseja sair sem salvar?';
      event.preventDefault();
      event.returnValue = message;
    }
  }

  public limparBuscaSalvaEstado(): void {
    this.filtroBuscaEstado.limpar(this.idModuloSelecionado ?? 234);
    this.buscaSalvaJaCarregada = false;
    this.modoEdicao = false;
    this.buscaSalvaId = null;
    this.savedSearchName = '';
    this.originalFiltersSnapshot = '';
    this.edicaoDirty = false;
    this.bloqueiaResetPadrao = false;
    setFiltrosSafe([]);
    this.filtrosSelecionados = {};
    this.estadoFiltros.setFiltros([]);
    this.filtrosChange.emit(this.filtrosSelecionados);
    this.inicializarFiltrosDefault();
  }
}
